<div class="card is-shadowless is-fullwidth is-fullheight">
  <h3
    class="title is-7 has-text-grey-dark is-uppercase has-text-weight-bold mb-3"
  >
    {{ aggregation.longLabel || aggregation.label }}
  </h3>

  <p class="subtitle is-7 has-text-grey" *ngIf="aggregation.description">
    {{ aggregation.description }}
  </p>

  <!-- Nav -->
  <nav class="level is-mobile is-flex mb-2">
    <div class="level-left">
      <div class="level-item" *ngIf="aggregation.datasets.length > 1">
        <div class="select is-small">
          <select name="dataset-select" (change)="selectDataset($event.target)">
            <option
              [value]="dataset.id"
              *ngFor="let dataset of aggregation.datasets"
            >
              {{ dataset.label }}
            </option>
          </select>
        </div>
      </div>
    </div>
    <div class="level-right">
      <div class="level-item">
        <a
          class="button is-small is-link-light is-hidden-touch"
          *ngIf="selectedDataset?.csv"
          (click)="downloadDataset(selectedDataset)"
        >
          <span>Download dataset</span>
          <span class="icon is-small">
            <i class="fa-solid fa-file-download"></i>
          </span>
        </a>
        <a
          class="button is-small is-link-light is-hidden-desktop"
          *ngIf="selectedDataset?.csv"
          (click)="downloadDataset(selectedDataset)"
        >
          <span class="icon is-small">
            <i class="fa-solid fa-file-download"></i>
          </span>
        </a>
      </div>
    </div>
  </nav>

  <!-- Chart -->
  <ng-container *ngIf="selectedDataset">
    <app-sunburst
      *ngIf="aggregation.chartTypes[0] === ChartType.Sunburst"
      [dataset]="selectedDataset"
    ></app-sunburst>
    <app-stacked-bar
      *ngIf="aggregation.chartTypes[0] === ChartType.StackedBarChart"
      [dataset]="selectedDataset"
    ></app-stacked-bar>
    <app-world-map
      *ngIf="aggregation.chartTypes[0] === ChartType.WorldMap"
      [dataset]="selectedDataset"
    ></app-world-map>
    <app-pie-chart
      *ngIf="aggregation.chartTypes[0] === ChartType.PieChart"
      [dataset]="selectedDataset"
    ></app-pie-chart>
    <app-iframe
      *ngIf="aggregation.chartTypes[0] === ChartType.Iframe"
      [dataset]="selectedDataset"
    >
    </app-iframe>
    <app-bar-chart
      *ngIf="aggregation.chartTypes[0] === ChartType.BarChart"
      [dataset]="selectedDataset"
    >
    </app-bar-chart>
    <app-scatter-plot
      *ngIf="aggregation.chartTypes[0] === ChartType.ScatterPlot"
      [dataset]="selectedDataset"
    >
    </app-scatter-plot>
  </ng-container>
</div>
